(function() { window.GUID_730222b1_e860_4bf1_9b9a_3496c872f9ae = { getGuid: function() { return "730222b1-e860-4bf1-9b9a-3496c872f9ae"; } }; })();
var CS;
(function (CS) {
    class AutoComplete {
        PrepareDataToSend(data) {
            data[this.HiddenValue[0].id] = this.HiddenValue.val(); // this.AutoComplete.val();//ca pogne le val de jquery... qui marche pas.
        }
        constructor(autocomplete, watermarkForceOn, showFocusedTooltip) {
            this.SearchTimeoutIndex = null;
            this.ScanHelper = new CS.ScanEntryHelper();
            this.FreezedElementScrollWhenOpen = null;
            this.HideElementWhenOpen = null;
            this.IdChanged = false;
            this.AlreadyActivated = false;
            this.DoNothingOnEnterKey = false;
            this.FirstClick = true;
            this.SelectionChange = null;
            this.SelectedElement = null;
            this.ItemCount = 0;
            //private searchAgainBecauseCtlrKeyIsPressed = false;
            this.bypassStayOpen = false;
            this.stayOpen = false;
            this.uiDiscovery(autocomplete, watermarkForceOn, showFocusedTooltip);
            this.bindEvent(autocomplete);
        }
        uiDiscovery(autocomplete, watermarkForceOn, showFocusedTooltip) {
            this.AutoComplete = autocomplete;
            this.WaterMark = this.AutoComplete.data('watermark');
            this.AutoCompleteId = autocomplete[0].id;
            this.KeepValueOnLostFocus = this.AutoComplete.data('keepvalueonlostfocus');
            this.AddedElementAtIndex0 = this.AutoComplete.data('addedelementatindex0');
            this.stayOpen = this.AutoComplete.data('stayopen');
            this.HiddenValue = $(':input[data-autocompleteidof="' + this.AutoCompleteId + '"]');
            let me = this;
            me.HiddenValue.data('context', me);
            me.AutoComplete.data('context', me);
            $(autocomplete[0]).CSWaterMark(watermarkForceOn, showFocusedTooltip);
            this.LastHiddenValue = this.HiddenValue.val();
            this.Url = autocomplete.data('autocompleteurl');
            this.Layout = autocomplete.data('autocompletelayout');
            this.LayoutItems = this.ExtractElementNamesInLayout();
            if (autocomplete.data('refreshelementids') != null) {
                this.RefreshElementIds = autocomplete.data('refreshelementids').split(',');
            }
        }
        bindEvent(autocomplete) {
            let me = this;
            this.ScanHelper.Scan = function (speed) {
                clearTimeout(me.SearchTimeoutIndex);
                me.HiddenValue.trigger('Scanned', me);
            };
            $(autocomplete).on('keydown.autocomplete', function (e) {
                var key = window.event ? e.keyCode : e.which;
                //me.searchAgainBecauseCtlrKeyIsPressed = e.ctrlKey;
                if (me.DoNothingOnEnterKey == true && key == 13) {
                    e.preventDefault();
                    return false;
                }
                if (me.Url != "") {
                    if (me.AlreadyActivated == false) {
                        me.ActivateAutocomplete();
                    }
                    if (me.AutoComplete.hasClass('watermark')) {
                        me.AutoComplete.removeClass('watermark');
                    }
                }
                me.ScanHelper.GrabInput(key);
            }).on('keyup.autocomplete', function (e) {
                var key = window.event ? e.keyCode : e.which;
                //me.searchAgainBecauseCtlrKeyIsPressed = e.ctrlKey;
                if (me.DoNothingOnEnterKey == false && key == 13 && !me.ScanHelper.IsScanned && me.AlreadyActivated) {
                    var actualText = $(me.AutoComplete).val();
                    // Mis en commentaire car ca fait apparaitre le dropdown apres la selection
                    //$(me.AutoComplete).autocomplete("search", actualText);
                    me.HiddenValue.trigger("EnterKey", actualText);
                }
            });
            $(autocomplete).on('blur.autocomplete', function (e) {
                me.bypassStayOpen = true;
                //if (IsDefined(typeof (currentTutorialItem)) && currentTutorialItem != null) {
                //    e.preventDefault();
                //    return;
                //}
                me.FirstClick = true;
                me.RefreshWaterMark(false);
            }).on('mouseup.autocomplete', function (e) {
                if (me.FirstClick == true) {
                    this.select();
                }
                me.FirstClick = false;
            }).on('focus.autocomplete', function (e) {
                me.RefreshWaterMark(true);
                me.bypassStayOpen = false;
            });
            me.RefreshWaterMark(false);
            return me;
        }
        val(newId, newText) {
            let me = this;
            if (newId != null && newText != null) {
                me.HiddenValue.val(newId);
                me.AutoComplete.val(newText);
                return me.HiddenValue.val();
            }
            else {
                return me.HiddenValue.val();
            }
        }
        Close() {
            let me = this;
            $('#' + me.AutoCompleteId + 'List').hide();
        }
        HasResult() {
            let me = this;
            return me.ItemCount > 0;
        }
        Prepare() { }
        ActivateAutocomplete() {
            var me = this;
            if (this.AlreadyActivated == false) {
                var autoCompleteList = null;
                $(me.AutoComplete).autocomplete({
                    source: function (request, response) {
                        var data = CS.PrepareDataToSendGlobal(me);
                        data.term = request.term;
                        data.actualValue = me.HiddenValue.val();
                        CompuSport.Ajax.Get(me.Url, data, function (data) {
                            me.ItemCount = data.length;
                            if (data.length == 0 || data == "") {
                                var displayText = JSRess.NoResultFound;
                                var customClass = "NoResult";
                                var value = "||NoResult||";
                                if (me.AddedElementAtIndex0 != null && me.AddedElementAtIndex0 != "") {
                                    displayText = me.AddedElementAtIndex0;
                                    customClass = "AddedElementAtIndex0";
                                    value = "||AddedElementAtIndex0||";
                                }
                                data = [];
                                let newItem = {
                                    label: displayText,
                                    value: value,
                                    customClass: customClass
                                };
                                data.push(newItem);
                            }
                            else if (me.AddedElementAtIndex0 != null && me.AddedElementAtIndex0 != "") {
                                let newItem = {
                                    label: me.AddedElementAtIndex0,
                                    value: "||AddedElementAtIndex0||",
                                    customClass: "AddedElementAtIndex0"
                                };
                                data.splice(0, 0, newItem);
                            }
                            var $data = $(data);
                            if (!$data.hasClass('ByPassAutoCompleteDropDown')) {
                                response($.map(data, function (item) {
                                    return {
                                        label: item.label,
                                        value: item
                                    };
                                }));
                            }
                            else {
                                me.HiddenValue.trigger("AutoCompleteBypassed", $data);
                            }
                        });
                    },
                    open: function (event, ui) {
                        if (me.FreezedElementScrollWhenOpen != null) {
                            me.FreezedElementScrollWhenOpen.addClass('OverflowHidden');
                        }
                        if (me.HideElementWhenOpen != null) {
                            me.HideElementWhenOpen.hide();
                        }
                        autoCompleteList.css('max-height', (CS.body.height() - me.AutoComplete.height()) - me.AutoComplete.offset().top);
                    },
                    close: function (event, ui) {
                        console.log('close');
                        if (me.FreezedElementScrollWhenOpen != null) {
                            me.FreezedElementScrollWhenOpen.removeClass('OverflowHidden');
                        }
                        if (me.HideElementWhenOpen != null) {
                            console.log('test');
                            me.HideElementWhenOpen.show();
                        }
                        if (me.stayOpen && !me.bypassStayOpen) {
                            me.AutoComplete.autocomplete("search", me.beforeSelectionText);
                            return false;
                        }
                        else {
                            me.bypassStayOpen = false;
                        }
                    },
                    minLength: 3,
                    select: function (event, ui) {
                        if (me.AutoComplete.val() != "") {
                            me.beforeSelectionText = me.AutoComplete.val();
                        }
                        me.UpdateSelection(ui);
                        event.preventDefault();
                    },
                    focus: function (event, ui) {
                        //me.searchingTimerIndex = 
                        return false;
                    },
                    change: function (event, ui) {
                        if (me.HiddenValue == null || me.HiddenValue.val() == '' || me.AutoComplete.val() == '') {
                            me.ClearValue();
                        }
                        event.preventDefault();
                    }
                }).data("ui-autocomplete")._renderItem = function (ul, item) {
                    console.log('autocomplete renderitem');
                    //Patch qui fait en sorte que en bundle, ca pete pas sinon, item était undefined
                    var actualItem = item;
                    if (me.IdChanged == false) {
                        ul[0].id = me.AutoCompleteId.replace(".", "_") + 'List';
                        me.IdChanged = true;
                    }
                    var li = $('<li>');
                    var anchor = $('<a>');
                    anchor.appendTo(li);
                    var divContainer = $('<div class="AutoCompleteItem">');
                    divContainer.appendTo(anchor);
                    let layout = eval($(me.Layout));
                    layout.appendTo(divContainer);
                    if (typeof (actualItem.value.customClass) != 'undefined') {
                        divContainer.addClass(actualItem.value.customClass);
                    }
                    if (typeof (actualItem.value.isActive) != 'undefined') {
                        var isActiveValue = actualItem.value.isActive;
                        if (isActiveValue == false) {
                            divContainer.addClass('translucent');
                        }
                    }
                    $.each(me.LayoutItems, function (index, value) {
                        var it = $('.' + value, anchor);
                        var itemValue = eval('actualItem.value.' + value);
                        if (it[0].tagName == 'IMG') {
                            if (itemValue != null && itemValue != "/cdn/app/images/default-player-v2.jpg" && itemValue != "/cdn/app/images/default-team-v2.jpg") {
                                it[0].src = itemValue;
                                it.attr('data-tooltip', '');
                            }
                            else {
                                it.hide();
                            }
                        }
                        else {
                            it.append(itemValue);
                        }
                    });
                    li.appendTo(ul);
                    return li;
                };
                //Fix pour que les dialog l'affiche complet
                autoCompleteList = me.AutoComplete.autocomplete("widget");
                autoCompleteList.detach().appendTo(CS.body);
            }
            this.AlreadyActivated = true;
        }
        ForceValue(value, label) {
            var me = this;
            var ui = {
                item: {
                    label: label,
                    value: {
                        value: {},
                        id: value
                    }
                }
            };
            me.UpdateSelection(ui);
        }
        UpdateSelection(ui) {
            var me = this;
            me.LastText = me.AutoComplete.val();
            if (ui != null && ui.item && ui.item.value.value == "||AddedElementAtIndex0||") {
                me.HiddenValue.trigger('AddedElementAtIndex0Click', me);
                // IsScanned to true to prevent raising EnterKey
                me.ScanHelper.IsScanned = true;
                return;
            }
            else if (ui != null && ui.item && ui.item.value.value != "||NoResult||") {
                me.SelectedItem = ui.item;
                me.AutoComplete.val(ui.item.label);
                if (me.HiddenValue.val() != ui.item.value.id.toString()) {
                    me.HiddenValue.val(ui.item.value.id);
                    me.SelectedElement = ui.item.value;
                }
            }
            else if (me.KeepValueOnLostFocus == "False") {
                me.SelectedItem = null;
                me.AutoComplete.val('');
                me.SelectedElement = null;
                if (me.HiddenValue != null && me.HiddenValue.val() != '') {
                    me.HiddenValue.val(null);
                }
            }
            if (ui == null) {
                if (me.LastHiddenValue != me.HiddenValue.val()) {
                    me.LastHiddenValue = me.HiddenValue.val();
                    if (me.SelectionChange != null) {
                        me.SelectionChange.call(me);
                    }
                    me.HiddenValue.trigger("CSChange", me);
                    me.HiddenValue.trigger("change", me);
                }
            }
            else {
                me.LastHiddenValue = me.HiddenValue.val();
                if (me.SelectionChange != null) {
                    me.SelectionChange.call(me);
                }
                me.HiddenValue.trigger("CSChange", me);
                me.HiddenValue.trigger("change", me);
            }
            this.RefreshWaterMark(false);
        }
        ClearValue() {
            this.ItemCount = 0;
            this.UpdateSelection(null);
            if (this.AutoComplete.is(":focus")) {
                this.AutoComplete.select();
            }
        }
        RefreshWaterMark(clearWaterMark) {
            if (clearWaterMark) {
                if (this.AutoComplete.val() == this.WaterMark && this.AutoComplete.hasClass('watermark')) {
                    this.AutoComplete.removeClass('watermark');
                    this.AutoComplete.val('');
                }
            }
            else {
                if ((this.AutoComplete.val() == '' || this.AutoComplete.val() == this.WaterMark) && !this.AutoComplete.is(":focus")) {
                    this.AutoComplete.val(this.WaterMark);
                    this.HiddenValue.val(null);
                    this.AutoComplete.addClass('watermark');
                }
                else if (!(this.AutoComplete.val() == this.WaterMark && this.AutoComplete.hasClass('watermark'))) {
                    this.AutoComplete.removeClass('watermark');
                }
            }
        }
        ExtractElementNamesInLayout() {
            //Dans le layout, on déclare comment les items de l'autocomplete seront affiché
            //Avec la fonction ExtractElementNames, je scan le layout pour trouver le nom de chaque 
            //class puisque ceux-ci correspondent au nom de champs de chaque valeurs.
            //Exemple : <div class="Prenom"></div><span class="Age"></span>
            //Ici, j'obtiendrais avec la fonction, une liste contenant "Prenom, Age"
            //pour ainsi binder les valeurs dans les bons éléments
            var _layout = $(this.Layout);
            var descendants = _layout.find("*");
            var list = [];
            $.each(descendants, function () {
                if (this.className != "") {
                    list.push(this.className);
                }
            });
            return list;
        }
    }
    CS.AutoComplete = AutoComplete;
})(CS || (CS = {}));

//# sourceMappingURL=cs.autocomplete.js.map
